import { ActionButton, DetailsHeader, DetailsList, DetailsListLayoutMode, IColumn, Icon, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IRenderFunction, Label, Link, MarqueeSelection, ProgressIndicator, Selection, SelectionMode, Stack, useTheme } from '@fluentui/react';
import * as React from 'react';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { PageTitle } from '../../PageTitle';
import { getAge } from '../../../Tools/DateTime';

interface IAttendeesListViewProps {
    userId?: string;
    title?: string;
    items: IAttendee[];
    statusMessage?: IStatusMessage;
    isLoading: boolean;
    addAttendee?: () => void;
    selectItem: (item: IAttendee[]) => void;
    deleteItem?: (id: number, userId: string) => void;   
    selectionMode: SelectionMode;
}


export const AttendeesListView: React.FunctionComponent<IAttendeesListViewProps> = (props) => {

    const theme = useTheme();

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    const [selected, setSelected] = React.useState<IAttendee[]>([]);
    const [columns, setColumns] = React.useState<IColumn[]>([
        { key: 'degree', name: 'Titul', fieldName: 'degree', minWidth: 35, maxWidth: 35, isResizable: true, styles: headerStyle },
        { key: 'firstName', name: 'Jméno', fieldName: 'firstName', minWidth: 60, maxWidth: 80, isResizable: true, styles: headerStyle },
        { key: 'lastName', isCollapsible: true, name: 'Příjení', fieldName: 'lastName', minWidth: 80, maxWidth: 200, isResizable: true, styles: headerStyle },
        { key: 'age', isCollapsible: true, name: 'Věk', fieldName: 'age', minWidth: 60, maxWidth: 80, isResizable: true, styles: headerStyle },
        { key: 'city', isCollapsible: true, name: 'Město', fieldName: 'city', minWidth: 60, maxWidth: 150, isResizable: true, styles: headerStyle }])


    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IAttendee[];
            setSelected(selected);
        },
    }));

    React.useEffect(() => {
        if (selected.length > 0) {
           props.selectItem(selected);
        }
    }, [selected])


    React.useEffect(() => {
        if (props.deleteItem) {
            if (!columns.find(x => x.key === 'deleteButton'))
                setColumns([...columns, { key: 'deleteButton', name: "delete", minWidth: 20, isIconOnly: true }]);
        }
    }, [props.deleteItem])
    

    const renderItemColumn = (item: IAttendee, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IAttendee];
            switch (column.key) {
                case 'age':
                    return <Stack horizontalAlign="start" styles={{ root: { paddingLeft: 15 } }}>{getAge(item.dateOfBirth)}</Stack>;

                case 'deleteButton':
                    return <div><Link title={fieldContent as string} onClick={() => { props.deleteItem && props.deleteItem(item.id, item.userId) }}><Icon styles={{ root: { fontSize: 16 } }} iconName="Delete" /></Link ></div> 
                default:
                    return <span style={{
                        height: '100%', display: 'flex', fontSize: 14,
                        alignItems: 'center'
                    }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {

            borderColor: theme.palette.blue,
            borderBottomWidth: 2,
            paddingTop:0

        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }
 
    return (
        <Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>
            {props.title ? <h2>{props.title}</h2> : null}
            {props.addAttendee ? <ActionButton iconProps={{ iconName: "Add" }} onClick={props.addAttendee} styles={{ root: { width: 200 } }}>Přidat další</ActionButton> : null}
            <Stack styles={{ root: { height: 10 } }}>
                {props.isLoading ? <ProgressIndicator /> : null}
            </Stack>
            <MarqueeSelection selection={selectionState}>
                <DetailsList
                    items={props.items}
                    columns={columns}
                    setKey="set"
                    onRenderDetailsHeader={onRenderDetailsHeader}
                    selectionMode={props.selectionMode}
                    layoutMode={DetailsListLayoutMode.justified}
                    onRenderItemColumn={renderItemColumn}
                    selection={selectionState}
                    selectionPreservedOnEmptyClick={false}
                    ariaLabelForSelectionColumn="Výběr události"
                    ariaLabelForSelectAllCheckbox="Výběr události"
                    checkButtonAriaLabel="Vyber řádek"
                    onItemInvoked={(item: IAttendee) => props.selectItem([item])}
                />
            </MarqueeSelection>
        </Stack>
    )
}

